import { TextField, TextFieldProps } from '@mui/material';
import { useField } from 'formik';

type FormikTextFieldProps = {
  name: string;
} & Omit<TextFieldProps, 'name'>;

export const FormikTextField = ({ name, ...props }: FormikTextFieldProps) => {
  const [field, meta] = useField(name);

  return (
    <TextField
      variant="filled"
      {...field}
      {...props}
      sx={{
        '& .MuiInputBase-input': { fontSize: '16px' },
        '& .MuiFormLabel-root': { fontSize: '14px' },
        ...props.sx,
      }}
      error={meta.touched && Boolean(meta.error)}
      helperText={meta.touched && meta.error}
      fullWidth
    />
  );
};
